import { ComputedItemFacet, IComputedItemFacetProps } from '../../models/itemCache/ComputedItemFacet';
import { Facet } from '../../models/Facet';
import { IItemCache } from '../../models/IItemCacheObserver';
import { itemIsReadOnlyControl } from '../../controls/itemIsReadOnlyControl';

/**
 * Facet which marks that an item is in a read-only state with respect to the user.
 * @public
 */
export const isReadOnlyFacet: Facet<boolean> = new ComputedItemFacet('isReadOnly', (
  itemCache: IItemCache,
  props: IComputedItemFacetProps
): boolean | undefined => {
  const {
    itemKey
  } = props;

  const controlHandler = itemCache.demandItemFacet(itemIsReadOnlyControl, itemKey);

  const {
    isReadOnly
  } = itemIsReadOnlyControl.evaluate(controlHandler)(itemCache, {
    itemKey
  });

  return isReadOnly;
});
